import { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance'
import { FiEdit2, FiTrash2 } from 'react-icons/fi'
import { MdOutlineClose } from 'react-icons/md'
import { RiAlertFill } from 'react-icons/ri'
import columns from './columns'
import toast from 'react-hot-toast'
import CustomModal from '../../components/common/CustomModal'

const BigTaskStatus = () => {
  const [data, setData] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isDeleteLoading, setIsDeleteLoading] = useState(false)
  const [selectedBigTaskStatus, setSelectedBigTaskStatus] = useState(null)
  const [pages, setPages] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalRows, setTotalRows] = useState(0)

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get('big-task-status/list', {
        page: pages,
        limit: limit,
      })
      if (response.status === 200) {
        const transformedData = response.data.result.docs.map((item) => ({
          ...item,
          actions: (
            <div className='flex items-center'>

              <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                <Link to={`edit/${item._id}`}>
                  <FiEdit2 className='w-4 h-4' />
                </Link>
              </div>
              <div
                className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'
                onClick={() => handleOpenDeleteModal(item._id)}
              >
                <FiTrash2 className='w-4 h-4' />
              </div>
            </div>
          ),
        }))
        setData(transformedData)
        setTotalRows(response.data.result.totalDocs)
      }
    } catch (error) {
      toast.error('Server Error!')
    }
  }

  useEffect(() => {
    fetchData()
  }, [pages, limit])

  const handleOpenDeleteModal = (id) => {
    setSelectedBigTaskStatus(id)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedBigTaskStatus(null)
  }

  const handlePageChange = (newPage) => {
    setPages(newPage)
  }

  const handleLimitPerPageChange = (newLimit) => {
    setLimit(newLimit)
    setPages(1)
  }

  const handleDelete = async () => {
    setIsDeleteLoading(true)
    try {
      const response = await axiosAuthInstance.delete(
        `big-task-status/delete/${selectedBigTaskStatus}`,
      )
      if (response.status === 200) {
        fetchData()
        setIsDeleteLoading(false)
        setIsModalOpen(false)

      }
    } catch (error) {
      setIsDeleteLoading(false)
      setIsModalOpen(false)
      toast.error('Failed to delete Big Task Status!')
    }
  }

  return (
    <div>
      <div className='flex items-center justify-between border-b px-4 pb-2'>
        <h1 className='text-2xl'>Big Task Status</h1>
        <Link to='/bigtaskstatus/add'>
          <button className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'>
            Add
          </button>
        </Link>
      </div>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[10, 20, 30]}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitPerPageChange}

      />
      {isModalOpen && (
        <CustomModal handleCloseModal={handleCloseModal}>
          <div className='p-4 relative'>
            <div
              className='absolute right-5 cursor-pointer hover:opacity-70'
              onClick={handleCloseModal}
            >
              <MdOutlineClose className='text-2xl' />
            </div>
            <div className='flex flex-col items-center justify-between gap-4'>
              <div className='flex flex-wrap justify-center alert-ico'>
                <RiAlertFill className='text-5xl' />
              </div>
              <h2>Are you sure you want to delete this Big Task Status?</h2>
              <div className='flex gap-4 mt-4'>
                <button
                  onClick={handleCloseModal}
                  className='bg-gray-300 px-4 py-2 rounded'
                >
                  No, Cancel
                </button>
                <button
                  onClick={handleDelete}
                  className='bg-red-500 text-white px-4 py-2 rounded'
                >
                  {isDeleteLoading ? (
                    <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent' />
                  ) : (
                    "Yes, I'm sure"
                  )}
                </button>
              </div>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  )
}

export default BigTaskStatus
